import { useRef, useState } from "react"
import { toast } from "react-toastify"
import { gsap } from "gsap"
import * as THREE from "three"
import { useThree } from "@react-three/fiber"

const ProjectPicture = ({node, message, link}) => {
  const ref = useRef()
  const {camera} = useThree()

  const checkDistance = () => {
    if (!ref.current) return
    const cameraPosition = new THREE.Vector3();
    camera.getWorldPosition(cameraPosition);
    const objectPositionVec = new THREE.Vector3(...ref.current.position); // розпаковуємо масив координат
    const distance = cameraPosition.distanceTo(objectPositionVec);

    return distance <= 4;
  };

  const onHoverHandler = () => {
    if (!checkDistance()) return
    const refMesh = ref.current;

    if (!refMesh) return;

    gsap.timeline()
      .to(refMesh.scale, { x: 1.1, y: 1.1, z: 1.1, duration: .15 })
  }

  const onHoverEndHandler = () => {
    const refMesh = ref.current;

    if (!refMesh) return;

    gsap.timeline()
      .to(refMesh.scale, { x: 1, y: 1, z: 1, duration: .15 })
  }

  return (
    <group
      onPointerOver={onHoverHandler}
      onPointerOut={onHoverEndHandler}
      onClick={() => {
        if (!checkDistance()) return
        navigator.clipboard.writeText(link)
        toast(message)
      }}
    >
      <primitive ref={ref} object={node} />
    </group>

  )
}

export {
  ProjectPicture,
}